'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getIsInForeground = exports.getIsInForeground = function getIsInForeground(state) {
  return state.clientData.isInForeground;
};


//////////////////
// WEBPACK FOOTER
// ./js/selectors/clientSelectors/getIsInForeground.js
// module id = 328
// module chunks = 2 3